import React from 'react'
import { reportClientError } from '../utils/errorReporting'

// Root error boundary — the last line of defense. Any render crash anywhere in
// the app lands here instead of a white screen: the user gets a friendly
// German fallback with a reload button, and the error (stack + component
// tree) is auto-reported to the error mailer via reportClientError.
export default class AppErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError (error) { return { error } }

  componentDidCatch (error, info) {
    console.error('[AppErrorBoundary]', error?.message, info?.componentStack)
    try { reportClientError('app-root', error, info) } catch {}
  }

  render () {
    if (!this.state.error) return this.props.children
    return (
      <div style={{
        minHeight: '100dvh',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        gap: 14, padding: 24, textAlign: 'center',
        background: 'linear-gradient(160deg, #fff7f0 0%, #ffffff 100%)',
        fontFamily: 'Inter, -apple-system, sans-serif',
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: 16,
          background: '#fff1e8', color: '#e85d1f',
          display: 'grid', placeItems: 'center',
          fontSize: 26,
        }}>⚠️</div>
        <h1 style={{ margin: 0, fontSize: 19, fontWeight: 700, color: '#1a1816' }}>
          Es ist ein Fehler aufgetreten
        </h1>
        <p style={{ margin: 0, maxWidth: 420, fontSize: 14, lineHeight: 1.55, color: '#6b6862' }}>
          Diese Ansicht hatte ein technisches Problem. Die Konferenz wird dadurch
          nicht beendet. Versuchen Sie zunächst, die Ansicht wiederherzustellen.
        </p>
        <button type="button" onClick={() => this.setState({ error: null })} style={{
          minHeight: 44, padding: '10px 22px', borderRadius: 999,
          background: '#e85d1f', color: '#fff', border: 0, cursor: 'pointer', fontWeight: 700,
        }}>Ansicht wiederherstellen</button>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            marginTop: 6, minHeight: 44, padding: '10px 22px', borderRadius: 999,
            background: '#e85d1f', color: '#fff', border: 0, cursor: 'pointer',
            fontSize: 14, fontWeight: 700, fontFamily: 'inherit',
            boxShadow: '0 8px 22px -8px rgba(232,93,31,0.5)',
          }}
        >
          Seite neu laden
        </button>
      </div>
    )
  }
}
